import React from 'react';
import {Tag, Tooltip} from 'antd';
import {ArrowRightOutlined} from '@ant-design/icons';
import {FileThumbnail} from '../FileThumbnail';
import {getExtFromName, getFileNameFromObsKey} from '../../utils/filePreview';
import {useObsThumbnail} from '../../hooks/useObsThumbnail';

interface RecentSearchCardProps {
  item: any;
  index: number;
  onClick: () => void;
}

export function RecentSearchCard({
                                   item,
                                   index,
                                   onClick
                                 }: RecentSearchCardProps) {
  const obskey = item.file || '';
  const fileName = getFileNameFromObsKey(obskey);
  const thumbnail = useObsThumbnail(obskey, fileName);

  const historyTags = item.tags
    ? item.tags.split(',').map((tag: string) => tag.trim()).filter(Boolean)
    : [];

  const visibleTags = historyTags.slice(0, 2);
  const hiddenTags = historyTags.slice(2);

  return (
    <div
      key={item.id || index}
      className="drive-search-recents__card"
      onClick={onClick}
    >
      <div className="drive-search-recents__title">
        {item.title || item.keywords || '最近搜索'}
        <ArrowRightOutlined className="drive-search-recnets__arrow"/>
      </div>

      <div className="drive-search-recents__content">
        {item.file && (
          <Tooltip
            title={getFileNameFromObsKey(item.file)}
            overlayClassName="drive-search-recents__tooltip"
          >
            <div className="drive-search-recents__thumb-wrap">
              <FileThumbnail
                file={{
                  type: 'file',
                  name: fileName,
                  extension: getExtFromName(item.file),
                  obskey: item.file,
                  thumbnail
                }}
              />
            </div>
          </Tooltip>
        )}

        {!!historyTags.length && (
          <div className="drive-search-recents__tags">
            {visibleTags.map((tag: string) => (
              <Tag className="drive-search-recents__tag" key={tag}>{tag}</Tag>
            ))}

            {hiddenTags.length > 0 && (
              <Tooltip
                overlayClassName="drive-search-recents__tooltip"
                title={
                  <div className="drive-search-recents__tag-tooltip">
                    {hiddenTags.map((tag: string) => (
                      <Tag className="drive-search-recents__tag" key={tag}>{tag}</Tag>
                    ))}
                  </div>
                }
              >
                <span className="drive-search-recents__tag-more">+{hiddenTags.length}</span>
              </Tooltip>
            )}
          </div>
        )}
      </div>

      <div className="drive-search-recents__desc">
        {item.description || item.content || '点击快速搜索'}
      </div>
    </div>
  );
}